import { render, staticRenderFns } from "./NavSlider.vue?vue&type=template&id=441671a2&scoped=true"
import script from "./NavSlider.vue?vue&type=script&lang=js"
export * from "./NavSlider.vue?vue&type=script&lang=js"
import style0 from "./NavSlider.vue?vue&type=style&index=0&id=441671a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441671a2",
  null
  
)

export default component.exports